import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Layout
import Layout from "./components/Layout";

// Pages
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import ProductsPage from "./pages/ProductsPage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import AboutPage from "./pages/AboutPage";
import ReviewsPage from "./pages/ReviewsPage";
import CartPage from "./pages/CartPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import BlogAdminPage from "./pages/BlogAdminPage";

// Context
import { CartProvider } from "./context/CartContext";

// API
import { seedDatabase } from "./lib/api";

function App() {
  useEffect(() => {
    // Seed database on first load
    seedDatabase().catch(console.error);
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="produits" element={<ProductsPage />} />
            <Route path="produits/:slug" element={<ProductPage />} />
            <Route path="journal" element={<BlogPage />} />
            <Route path="journal/:slug" element={<BlogArticlePage />} />
            <Route path="a-propos" element={<AboutPage />} />
            <Route path="avis" element={<ReviewsPage />} />
            <Route path="panier" element={<CartPage />} />
            <Route path="checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="admin/blog" element={<BlogAdminPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
